













































import { Component, Prop, PropSync, Vue, Watch } from 'vue-property-decorator';
import InvoiceAgencyDetailReport from './Report.vue';
import { get_agency_invoice_detail } from '@/api/invoice';
import { list_product_summaries } from '@/api/product';
import { CurrencyEnum } from '@/api/types';

@Component({
  name: 'InvoiceAgencyDetailReports',
  components: {
    InvoiceAgencyDetailReport,
  },
})
export default class extends Vue {
  @Prop({ default: false }) loading!: boolean;
  @Prop({ required: true })
  reports!: get_agency_invoice_detail.AgencySalesReports;
  @Prop({ required: true }) products!: Map<
    string,
    list_product_summaries.Product
  >;
  private openPanels = [0];

  // TODO: naive implementation despite of different currency in report, need to check
  get totalCurrency() {
    return this.reports && this.reports.reports.length > 0
      ? this.reports.reports[0].currency
      : CurrencyEnum.JPY;
  }
}
